import React from 'react';
import fire from '../firebase/firebase';
import TriGrid from '../shared/trigrid';
import stef from '../assets/img/stefblackwood.jpg';
import alex from '../assets/img/alexwhitney-scaled.jpg';
import bob from '../assets/img/bob-scaled.jpg';

class Team extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
        teamSummary: null,
        teamContent: null,
        teamStef: null,
        teamMemberOne: null,
        testimonialQuote: null,
        testimonialName: null,
        testimonialCompany: null,
        member1Name: null,
        member2Name: null
       };
    }

    componentDidMount() {

      let teamSummary = fire.database().ref('team-summary');
      let teamContent = fire.database().ref('team-main');
      let teamStef = fire.database().ref('team-stef-link');
      let teamMemberOne = fire.database().ref('team-member1-link');
      let teamMemberTwo = fire.database().ref('team-member2-link');
      let testimonialQuote = fire.database().ref('testimonial-quote');
      let testimonialName = fire.database().ref('testimonial-name');
      let testimonialCompany = fire.database().ref('testimonial-company');
      let member1Name = fire.database().ref('profile-member1-name');
      let member2Name = fire.database().ref('profile-member2-name');
      let stefName = fire.database().ref('profile-stef-name');

      teamSummary.on('value', snapshot => {
        this.setState({teamSummary: snapshot.val()});
      });
      teamContent.on('value', snapshot => {
        this.setState({teamContent: snapshot.val()});
      });
      teamStef.on('value', snapshot => {
        this.setState({teamStef: snapshot.val()});
      });
      teamMemberOne.on('value', snapshot => {
        this.setState({teamMemberOne: snapshot.val()});
      });
      teamMemberTwo.on('value', snapshot => {
        this.setState({teamMemberTwo: snapshot.val()});
      });
      testimonialQuote.on('value', snapshot => {
        this.setState({testimonialQuote: snapshot.val()});
      });
      testimonialName.on('value', snapshot => {
        this.setState({testimonialName: snapshot.val()});
      });
      testimonialCompany.on('value', snapshot => {
        this.setState({testimonialCompany: snapshot.val()});
      });
      member1Name.on('value', snapshot => {
        this.setState({member1Name: snapshot.val()});
      });
      member2Name.on('value', snapshot => {
        this.setState({member2Name: snapshot.val()});
      });
      stefName.on('value', snapshot => {
        this.setState({stefName: snapshot.val()});
      });
    }

  render() {
    return (
      <div>
        <div className="app-main-container">
          <div className="app-content__heading page-heading-container">
            <div className="app-header-container page-heading">
            <h1 className="heavy">About us<span className="eitx-orange">.</span></h1>
            <p>{this.state.teamSummary}</p>
            </div>
          </div>
          <div className="app-content main-content">
            <div dangerouslySetInnerHTML={{__html: this.state.teamContent}}  className="app-content--two-thirds-summary"></div>
            <div className="app-content--one-third-right testimonial__container">
              <div className="testimonial">
                <h2>"{this.state.testimonialQuote}"</h2>
                <div className="testimonial__detail">
                  <p>{this.state.testimonialName} - <span className="eitx-orange">{this.state.testimonialCompany}</span></p>
                </div>
              </div>
            </div>
            <div className="app-content main-content">
            <div className="app-tri-grid">
              <TriGrid title={this.state.stefName} summary={this.state.teamStef} img={stef} link="stefanblackwood"/>
              <TriGrid title={this.state.member1Name} summary={this.state.teamMemberOne} img={bob} link="bobspencer"/>
              <TriGrid title={this.state.member2Name} summary={this.state.teamMemberTwo} img={alex} link="alexwhitney"/>
            </div>
          </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Team;



// WEBPACK FOOTER //
// ./src/pages/team.js